import React from "react";

import { Box, Flex } from "@chakra-ui/react";

import Group from "../../../pages/ServicosAcolhimento/Visualizar/Group";
import Information from "../Information";
import { TableEducacao } from "../../TableEducacao";
import { IconeDownload } from "../../IconeDownload";

export const Educacao = ({ data }) => {
  const columns = [
    {
      Header: "Nome",
      accessor: "nome",
      Cell: (props) => {
        const { value } = props;
        const truncatedValue =
          value && value?.length > 120 ? value?.slice(0, 120) + "..." : value;

        return <span style={{ wordBreak: "break-all" }}>{truncatedValue}</span>;
      },
    },
    {
      Header: "Escola Atual",
      accessor: "escolaAtual",
      Cell: (props) => {
        return <span>{props?.value === "S" ? "Sim" : ""}</span>;
      },
    },
    {
      Header: "Comprovante de Matrícula Escolar",
      accessor: "matriculaAnexo",
      Cell: (props) => {
        return (
          <Flex justifyContent={"center"}>
            {props?.value ? <IconeDownload /> : ""}
          </Flex>
        );
      },
    },
  ];

  return data ? (
    <Box className="break-page">
      <Flex>
        <Group bgColor="#fff" title="Educação" py="12px" mtDivider="5px">
          <Information
            title="Frequenta escola?"
            information={data.frequentaEscola === "S" ? "Sim" : "Não"}
            mt="10px"
          />
          {data.tipoJustificativaEscolaridade && (
            <Information
              title="Justificativa"
              information={
                data.tipoJustificativaEscolaridade.id === 6 ? (
                  <>
                    {data.tipoJustificativaEscolaridade.descricao}{" "}
                    {data.justificativaEscolaridade}
                  </>
                ) : (
                  <>{data.tipoJustificativaEscolaridade.descricao}</>
                )
              }
              mt="10px"
            />
          )}

          {data.frequentaEscola === "S" ? (
            <Information
              title="Educação especial?"
              information={data.educacaoEspecial === "S" ? "Sim" : "Não"}
              mt="10px"
            />
          ) : (
            ""
          )}

          {data.escolaridade && (
            <Information
              title="Escolaridade"
              information={data.escolaridade.descricao}
              mt="10px"
            />
          )}

          {data.frequentaEscola === "S" && (
            <Information
              title="Escolaridade Repetida"
              information={data.escolaridadeRepetida === "S" ? "Sim" : "Não"}
              mt="10px"
            />
          )}

          {data?.unidadesEscolares && data?.unidadesEscolares.length > 0 && (
            <TableEducacao
              columns={columns}
              data={data?.unidadesEscolares}
              frequentaEscola={data.frequentaEscola}
            />
          )}
        </Group>
      </Flex>
    </Box>
  ) : (
    <Box className="break-page">
      <Flex>
        <Group
          bgColor="#fff"
          title="Educação"
          mt="15px"
          py="12px"
          mtDivider="5px"
        />
      </Flex>
    </Box>
  );
};
